var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-32 mb-56"},[_c('RasmusResetPasswordFromHashForm',{attrs:{"uid":_vm.uid,"hash":_vm.hash,"loginLink":_vm.loginLink}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }